import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import classnames from 'classnames';
import common from 'constants/common';

const getCovidStatusLabel = (status) =>
  status === common.covidStatuses.positive.status
    ? common.covidStatuses.positive.label
    : '';

const checkIsInactive = (status) =>
  status === common.covidStatuses.negative.status;

const PatientCovidStatusBadge = ({ profile, patientDetailsLoading }) => {
  const { covidStatus } = profile;
  const isInactive = useMemo(() => checkIsInactive(covidStatus), [covidStatus]);

  return (
    <div
      className={classnames(
        'covid-badge',
        {
          'active-badge': !patientDetailsLoading && !isInactive,
        },
        { 'inactive-badge': isInactive },
      )}
    >
      {!isInactive && (
        <div className="status">{getCovidStatusLabel(covidStatus)}</div>
      )}
    </div>
  );
};

PatientCovidStatusBadge.defaultProps = {
  patientDetailsLoading: false,
};

PatientCovidStatusBadge.propTypes = {
  profile: PropTypes.shape().isRequired,
  patientDetailsLoading: PropTypes.bool,
};

export default PatientCovidStatusBadge;
